import * as React from "react";
import type { SVGProps } from "react";
const SvgFullscreenOffIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="fullscreen_off_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M469.333 426.667a42.667 42.667 0 0 1-42.666 42.666H256A42.667 42.667 0 1 1 256 384h67.67l-97.835-97.835a42.667 42.667 0 0 1 60.33-60.33L384 323.669V256a42.667 42.667 0 0 1 85.333 0v170.667zm97.92 140.373a42.539 42.539 0 0 1 30.08-12.373H768A42.667 42.667 0 1 1 768 640h-67.67l97.835 97.835a42.667 42.667 0 0 1-60.33 60.33L640 700.331V768a42.667 42.667 0 1 1-85.333 0V597.333a42.539 42.539 0 0 1 12.373-30.08l.213-.17z"
    />
    <path
      fill="currentColor"
      d="M810.667 170.667a42.667 42.667 0 0 1 42.666 42.666v597.334a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V213.333a42.667 42.667 0 0 1 42.666-42.666h597.334zM213.333 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H213.333z"
    />
  </svg>
);
export default SvgFullscreenOffIcon;
